module.exports = __webpack_public_path__ + "img/1610.8792c179.png";